import zhMessages from 'locales/zh/messages';
import enUsMessages from 'locales/en-US/messages';
import { addLocaleData } from 'react-intl';
import enLocaleData from 'react-intl/locale-data/en';
import zhLocaleData from 'react-intl/locale-data/zh';

const DEFAULT_LOCALE = 'zh';

function getMessages (locale) {
  // TODO: make it more robust and flexible
  switch (locale) {
    case 'zh' : return zhMessages;
    default: return enUsMessages;
  }
}

function getLocale (store) {
  return store.getState().locale || DEFAULT_LOCALE;
}

function init () {
  addLocaleData(enLocaleData);
  addLocaleData(zhLocaleData);
}

export default {
  getMessages,
  getLocale,
  init,
  DEFAULT_LOCALE
};



/** WEBPACK FOOTER **
 ** ./src/services/localeService.js
 **/